

import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Container,
  Grid,
  CircularProgress,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import MyCardBoard from '../../components/ArrangeProducts'  
import AppBreadcrumbs from "../../components/AppBreadcrumbs";



const EditButton = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (auth !== null) {
      setIsLoading(false);
    }
  }, [auth]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col p-4">
      <div className="w-full max-w-[1600px] mx-auto space-y-6">
              <AppBreadcrumbs />

      <MyCardBoard />
    </div>
    </div>
  );
};

export default EditButton;
